import React from "react"
import AuthRoute from "../../common/AuthRoute"
import { SellerList } from "./components/containers"
import { CrownOutlined } from "@ant-design/icons"

export default {
  sideBarItems: [
    {
      icon: <CrownOutlined />,
      name: "Sellers",
      path: "seller_list",
    },
  ],
  routes: [
    <AuthRoute
      exact
      key="/seller_list"
      path="/seller_list"
      render={() => <SellerList />}
    />,
  ],
}
